import React from 'react';
import { Form, Icon, Input, Button, Spin, Row, Col } from 'antd';
import { Redirect, withRouter, Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import axios from "axios";
import './style.css';

const FormItem = Form.Item;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


class PasswordResetConfirmForm extends React.Component {
    state = {

    };

    componentDidMount() {
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log(this.props);
                const postObj = {
                    new_password1: values.new_password1,
                    new_password2: values.new_password2,
                    uid: this.props.match.params.uid,
                    token: this.props.match.params.token
                }

                axios.post(process.env.REACT_APP_AXIOS_URL + "/rest-auth/password/reset/confirm/", postObj)
                    .then(res => {
                        // if (res.status === 200) {
                        // message.success(this.props.t('clients.client_service_form.message_sent', "Message sent"));
                        this.props.history.push({
                            pathname: '/login/',
                            state: { message: this.props.t('auth.password_reset_confirm.confirm', "Your password have been updated. Now you can login.") }
                        });
                        // }
                    });
                // this.props.history.push('/');
            }
        });
    }

    render() {
        const { t } = this.props;
        const { getFieldDecorator } = this.props.form;

        if (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined) {
            return (
                <Row>
                    <Col md={12}>
                        <div className="login-page-background-image">

                        </div>
                    </Col>
                    <Col md={12} style={{ height: '100vh' }}>
                        <div className="login-wrap">
                            <img src="/static/nerisit-logo-final-light.png" className='login-logo-img'></img>
                            <p className='pStyle' style={{ textAlign: 'center' }}>Enter a new password for your account</p>
                            {
                                this.props.loading ?

                                    <Spin indicator={antIcon} />

                                    :

                                    <Form onSubmit={this.handleSubmit} className="login-form">
                                        <FormItem>
                                            {getFieldDecorator('new_password1', {
                                                rules: [{ required: true, message: t('auth.password_reset_confirm.password1_required', "Please input your new password!") }],
                                            })(
                                                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder={t('auth.password_reset_confirm.password1', "New password")} />
                                            )}
                                        </FormItem>

                                        <FormItem>
                                            {getFieldDecorator('new_password2', {
                                                rules: [{ required: true, message: t('auth.password_reset_confirm.password2_required', "Please confirm your new password!") }],
                                            })(
                                                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder={t('auth.password_reset_confirm.password2', "Confirm new password")} />
                                            )}
                                        </FormItem>

                                        <FormItem>
                                            <Link
                                                className='login-form-forgot'
                                                // style={{ marginRight: '10px' }}
                                                to='/login/'> {t('auth.password_reset_confirm.login', "Login")}
                                            </Link>
                                            <Button type="primary" htmlType="submit" className="login-form-button">
                                                {t('auth.password_reset_confirm.reset', "Set new password")}
                                            </Button>
                                        </FormItem>
                                    </Form>
                            }
                        </div>
                    </Col>
                </Row>
            );
        } else {
            return (<Redirect to="/" />);
        }
    }
}

const WrappedPasswordResetConfirmForm = Form.create()(PasswordResetConfirmForm);

export default withRouter(withTranslation()(WrappedPasswordResetConfirmForm));


// WEBPACK FOOTER //
// ./src/containers/Auth/PasswordResetConfirm.js